import { useState } from 'react'
import { FieldGroup, FormCard } from '../components/reusable'

const getWidth = () => {
    const clientWidth = document.body.clientWidth
    if (clientWidth > 720) {
        return 720
    }
    if (clientWidth <= 720 && clientWidth > 580) {
        return 580
    }
    if (clientWidth < 580) {
        return clientWidth - 90
    }
    return 0
}

function ThankyouBoshhh(props: any) {
    const { isActive } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const width = getWidth()
    const height = Number(width / 1.8).toFixed(0)

    return (
        <FieldGroup title="Claim Complete">
            <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                <h2
                    style={{
                        color: '#434343',
                        textAlign: 'center',
                        marginTop: 0,
                        marginBottom: 0,
                    }}
                >
                    Thank you!
                </h2>
                <p
                    style={{
                        color: '#434343',
                        textAlign: 'center',
                        marginTop: '10px',
                        marginBottom: '30px',
                    }}
                >
                    Thank you for completing your Boshhh journey
                </p>
                <span
                    style={{
                        height: '2px',
                        width: '60px',
                        display: 'block',
                        background: '#b3b3b3',
                        margin: '0 auto',
                    }}
                ></span>
                <p
                    style={{
                        textAlign: 'center',
                        color: '#434343',
                        marginTop: '30px',
                        marginBottom: '0px',
                        fontWeight: '600',
                        letterSpacing: '1px',
                    }}
                >
                    We'll be in touch soon to discuss your next steps.
                </p>
            </FormCard>
        </FieldGroup>
    )
}

export default ThankyouBoshhh
